<section *ngIf="showSection && !isListMode" class="breadcrumbs-placeholder">
</section>
<section *ngIf="showSection && !isListMode" class="index h-75 d-flex">
  <div class="container container-index">
    <div class="row justify-content-around align-content-center art-group h-75">
      <app-booking-area-item-pack class="col-12 col-md-4 pb-4" *ngFor="let areaItemPack of areaItemPacks"
        [areaItemPack]="areaItemPack" [maxLenNamePack]="maxLenNamePack"
        (areaItemSelected)="onClick(areaItemPack, $event)"></app-booking-area-item-pack>
    </div>
  </div>
</section>
<section *ngIf="showSection && isListMode" class="index d-flex">
  <div class="container container-wrapper page-container">
    <div class="row page-container-content">
      <div *ngFor="let areaItemPack of areaItemPacks" class="col-12 col-xl-6">
        <app-booking-area-item-pack [areaItemPack]="areaItemPack" [maxLenNamePack]="maxLenNamePack"
          [viewType]="viewType" (areaItemSelected)="onClick(areaItemPack, $event)">
        </app-booking-area-item-pack>
      </div>
    </div>
  </div>
</section>
<!-- <section *ngIf="showSection">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-8 col-md-3">
        <hr>
      </div>
    </div>
  </div>
</section>
<section *ngIf="showSection">
  <app-booking-contact-us></app-booking-contact-us>
</section> -->
